exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-dropdown-trigger[data-v-5a83d6fa]{height:48px;padding:0 1rem}.list-reset[data-v-5a83d6fa]{box-shadow:0 4px 4px rgba(0,0,0,.15)}", ""]);

// exports
